module.exports = __webpack_public_path__ + "img/好居新房安装成功.ec30f05e.svg";